
import React, { useEffect, useState } from 'react';
import { Item, Image, Header, Table, Input, Message, Checkbox, Button, Dropdown, Container, Grid } from 'semantic-ui-react'

import UserCardsMessage from '../messages/UserCardsMessage'
import AddMemberGroup from './AddMemberGroup';
import { MyStore } from "../../../../services/Store"


import moment from 'moment'


export   function Step2a_Edit(props) {

    const [members, setMembers] = useState()
    const [length, setLength] = useState()
    const [currentGroup, setCurrentGroup] = useState({})
    const [leaders, setLeaders] = useState({})
    const [mbrProjects, setMbrProjects] = useState()
    
    const [currentCardId, setCurrentCardId] = useState()

    const [state, setState] = useState({
        visible: false
    })

    // const [role, setRole] = useState({})

    const [invites, setInvites] = useState()
    //  const [roleKeys, setRoleKeys] = useState()
    // const recipeKey = '-LwLujWwcsr6szQxZYer';
    const recipeKey = props.oid

    const databaseRef = MyStore.database().ref();

    // this.setState({data: data});

    let cg = []



    useEffect(() => {

        // console.log(props)
     
             MyStore.auth().onAuthStateChanged((user) => {
                //  console.log(' --- line 47 --- user')
                //  console.log(user)
                 if (user) {
                     
                     MyStore.database().ref().child(`/groups/${recipeKey}`).on('value', snap => {
 
                         setCurrentGroup((snap.val()))
                         // let length = Object.keys(currentGroup.members).length
     
                         let myArr = []
                        //  console.log('----------- function 02 -------------')
                        //  console.log(snap.val())
     
                         for (const key in snap.val().members) {
                             myArr.push(Object.assign({}, snap.val().members[key]));
                         }
                         if (snap.val() != null) {
                             // users = myArr
                             cg = myArr
                            //  console.log(cg)
                             setMembers(cg)
                             // setState({myArr})
                         }
     
     
                         let inviteArr = []
                         let temp_roles = []
                         let count = 0
                         let roleKey = 0
                         for (const key in snap.val().invites) {
                             const keyObject = snap.val().invites[key]
                             keyObject['role'] = ''
                             keyObject['key'] = count++
                             inviteArr.push(Object.assign({}, (keyObject)));
                             temp_roles.push(Object.assign({}, ({ role: '', key: roleKey++, uid: snap.val().invites[key].uid })));
                         }
                         if (snap.val().invites != null) {
                             setInvites(inviteArr)
                             // setRoleKeys(temp_roles)
                             // setState({myArr})
                         }
     
                     });
     
     
                 }// end of if
     
                 let currentUserUid = MyStore.auth().currentUser.uid
                 // const filelogid = '6d3a17f7-3ebc-4939-abf6-447cffebaafe'
                 const filelogid = props.filelogid
                 const oid = props.oid
     
                 MyStore.database().ref().child(`/groups/${oid}`).child('mbrcards').child(filelogid).on('value', snap => {
                    //  console.log(snap.val())
     
                     let myArr = []
                    //  console.log('----------- function 02 -------------')
                    //  console.log(snap.val())
     
                     for (const key in snap.val()) {
                         myArr.push(Object.assign({}, snap.val()[key]));
                     }
                     if (snap.val() != null) {
                         // users = myArr
                         // cg = myArr/
                         setMbrProjects(myArr)
                         // console.log(myArr)
                         // setState({myArr})
                     }
     
     
                 })
    
             })
     
         }, []);
     

    

        const handleAddCadreMembers = (key) => {
            // console.log(typeof(role))
            // console.log('--------------  handleInvites -----------------')
            // console.log(props)
    
            // if (roleKeys[key].role == "") {
            //     return
            // }
    
            // console.log(invites[key])
            const tempInvite = members[key]
    
            // console.log(members[key])
            // const tempInvite = invites[roles.key]
    
            const inivitedUser = {
                avatar: tempInvite.avatar,
                uid: tempInvite.uid,
                username: tempInvite.username,
                displayName:  tempInvite.displayName,
                role: tempInvite.role,
                // role: roleKeys[key].role,
                timestamp: Date.now(),
                momentTimestamp: moment().format('LLL')
            }
            // console.log(inivitedUser)
    
            // const cardId = '-M0a4x5v51tgt9HL6OET'
    
            if(props.cardId !== undefined && props.filelogid!== undefined){
                // console.log(props)
                setCurrentCardId(props.cardId)
                const cardId = props.cardId
    
                const currentMbrProjects = {
                    id: cardId, 
                    isMember: true,
                }
                // const filelogid = '6d3a17f7-3ebc-4939-abf6-447cffebaafe'
        
                const filelogid = props.filelogid
                // console.log('filesGroupId')
                // console.log(filelogid)
                // console.log(props.filelogid)
                databaseRef.child(`/groups/${props.oid}`).child('mbrcards').child(filelogid).child(inivitedUser.uid).set(inivitedUser)
                databaseRef.child(`/groups/${props.oid}`).child('mbrprojects').child(inivitedUser.uid).child('cards').child(filelogid).set(currentMbrProjects)
                
                
            }
           
         
        }
        

        // console.log('------------ state -----------')

        // console.log(currentGroup)
        // console.log(currentGroup.currentUsers)
        // console.log(members)
        if (members && currentGroup) {
            // console.log(members)
            // console.log(Object.keys(currentGroup.members).length)
    
        }



         const handleClick = (value) => {
            // console.log(value)
            handleAddCadreMembers(value)
        }
    

         const displayCadreMembers = () => {
            const currentInvite = []
            if (typeof (members) == 'object') {
                return (
                    Array.from(members.keys()).map(key => (
                        <Table.Row key={key} style={{ minHeight: '1vh' }}  >
                            {/* {console.log(' key in display cadre members ')} */}
                            {/* {console.log(key)} */}
                            <Table.Cell style={{ width: '1px' }} >
                                <Header as='h1' image>
                                    <Image src={members[key].avatar} width="64" height="64"  ></Image>
                                </Header>
                            </Table.Cell>
                            <Table.Cell style={{ width: '13vh' }}> <b> {members[key].displayName}</b> <br></br>{members[key].username}  </Table.Cell>
                            <Table.Cell style={{ width: '13vh' }}>
    
    
                                <b>{members[key].role}{'   '}</b>
    
    
                            </Table.Cell>
                            <Table.HeaderCell style={{ width: '3vh' }} >
                                <Button icon='add user' size='large'
                                    value={key}
                                    onClick={() => handleClick(key)}
                                >
                                </Button> </Table.HeaderCell>
                        </Table.Row>
                    ))
                )
            }
        }

        
    
    if (props.currentStep !== 2) {
        return null
    } 

    // const handleChange = (event) => {
    //     this.setState({ 
    //      [event.target.getAttribute('data-field')]: event.target.value,
    //       members: {
    //         ...this.props.members,
    //         [`${event.target.getAttribute('data-field')}2`]: event.target.value,
    //       }  
    //     });
    //   }

    return (
        <div style={{ 
            
         }}>

            {/* <Header as='h1' textAlign='center'> Delivery</Header> */}
            <Container style={{}} className='mbrProjects'>



                <AddMemberGroup
                    currentGroup={currentGroup}
                    currentUser={MyStore.auth().currentUser}
                    isDM={false}
                    leaders={currentGroup.currentUsers
                
                        // leaders={MyStore.database().ref().child("usernames")

                    }
                    filelogid={props.filelogid}
                />

                {/* {console.log('------ line 401 ')}
                {console.log(mbrProjects)}
                {console.log(MyStore.auth().currentUser.uid)} */}


            {mbrProjects=== undefined ? null: 
            
            <UserCardsMessage 
            filelogid={props.filelogid}
            cardId = {props.cardId}
          members={mbrProjects}
          key={mbrProjects.keys()}
          ></UserCardsMessage>
            }
      
            </Container>


            {/* 
            <UserCardsMessage members = {members}></UserCardsMessage> */}
            <div className="form-group">


                {/* <Table inverted textAlign='center'  
                    style={{
                        background: "transparent",
                        border: "1px solid black",
                        boxShadow: "none",
                        padding: "0em 0em",
                        textAlign: 'justified',
                    }}

                >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ width: '1px' }} />
                            <Table.HeaderCell style={{ width: '25vh' }}><Header>Member</Header></Table.HeaderCell>
                            <Table.HeaderCell ><Header>Role</Header></Table.HeaderCell>
                            <Table.HeaderCell style={{ width: '1px' }} />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                    

                    {displayMbrMembers()}

                    </Table.Body>
                </Table>
                     */}


                <Container className='cadreMembersTable'>

                    <Table textAlign='center' inverted color={'teal'}
                        style={{
                            // background: "transparent",
                            border: "3px solid #00D6CD",
                            boxShadow: "none",
                            padding: "0em 0em",
                            textAlign: 'justified',
                            minHeight: '45vh'
                        }}

                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell style={{ width: '1px' }} />
                                <Table.HeaderCell style={{ width: '20h' }}><Header style={{ color: 'white' }}> Cadre Members</Header></Table.HeaderCell>
                                <Table.HeaderCell ><Header style={{ color: 'white' }}>Role</Header></Table.HeaderCell>
                                <Table.HeaderCell style={{ width: '1px' }} />
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {/* {displayCurrentMembers()} */}
                            {displayCadreMembers()}
                            {/* {displayCadreMembers()}
                    {displayCadreMembers()}
                            {displayCadreMembers()} */}
                        </Table.Body>
                    </Table>


                </Container>



            


                    {state.visible ? (
                            <Container className='contactMembersTable'>
                        <Table inverted color={'blue'} textAlign='center'
                            style={{
                                // background: "transparent",
                                border: "3px solid #3AC0FF",
                                boxShadow: "none",
                                padding: "0em 0em",
                                textAlign: 'justified',
                                minHeight: '45vh'

                            }}

                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell style={{ width: '1px' }} />
                                    <Table.HeaderCell style={{ width: '25vh' }}><Header style={{ color: 'white' }}>Contacts</Header></Table.HeaderCell>
                                    <Table.HeaderCell ><Header style={{ color: 'white' }}>Role</Header></Table.HeaderCell>
                                    <Table.HeaderCell style={{ width: '1px' }} />
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>



                                {/* {displayCadreMembers()} */}
                                {/* {displayCadreMembers()}
                {displayCadreMembers()} */}
                            </Table.Body>
                        </Table>
                                </Container>
                    ) : null
                    }




        







            </div>
         
        </div>
    );
}


